import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const SnackBar = ({open, handleClose, severity="success", message}) => {
    return (<Snackbar
      open={open}
      anchorOrigin={{ vertical:'bottom', horizontal:'center' }}
      autoHideDuration={6000}
      onClose={handleClose}
      
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>)
  }

  export { SnackBar }